export const ACTION_RESET = 'FETCH_PRESSDATALIST_RESET';
export const ACTION_REQUEST = 'FETCH_PRESSDATALIST_REQUEST';
export const ACTION_SUCCESS = 'FETCH_PRESSDATALIST_SUCCESS';
export const ACTION_ERROR = 'FETCH_PRESSDATALIST_ERROR';
